import { IconDownCaret, IconUpCaret } from "components/icons/Icons";
import React, { useState } from "react";
import { sortBy, stringReplace } from "utils";

import OptionResultItem from "components/results/OptionResultItem";
import PropTypes from "prop-types";
import { QuestionSubType } from "consts";
import classNames from "classnames";
import i18n from "micro-i18n";

//FIXME: SOF-617 requires the following imports to be moved to components/widget-components.scss
// due to lazy loading of the widget inside an iframe. Keeping this here for potential fix down the road.
// import 'components/results/OptionResult.scss';

const OptionResult = ({ result, isActive }) => {
  const { options, id, role, quiz, subtype } = result;
  const [selectExpanded, setSelectExpanded] = useState(false);
  const isQuiz = role && role === "quiz"; // FIXME: Are their other roles for an ENUM?
  const isCorrect = isQuiz && quiz && quiz.correct;
  const quizTextId = isCorrect ? "QUIZ_RIGHT_ANSWER" : "QUIZ_WRONG_ANSWER";
  const isSelect = subtype === QuestionSubType.Select;
  const sortedOptions = sortBy(options, "answered", "desc");
  const collapsedMax = 3;
  const isCollapsible = sortedOptions.length > collapsedMax;

  const optId = stringReplace(id, "/", "-");

  const onSelectExpand = () => setSelectExpanded(!selectExpanded);

  return (
    <div
      className={classNames("csw-option-result", {
        "csw-quiz-result": isQuiz,
        "csw-option-result-select": isSelect,
        "csw-option-result-select-expanded": isSelect && selectExpanded,
      })}
    >
      {isQuiz && <div className={isCorrect ? "csw-success" : "csw-fail"}>{i18n.t(quizTextId)}</div>}

      {sortedOptions &&
        sortedOptions.map((option, index) => {
          const { answered } = option;
          const isExpanded = !isSelect || selectExpanded || index < collapsedMax || answered;
          return isExpanded ? (
            <OptionResultItem option={option} key={`csw-r-option-row-${optId}-${index}`} isActive={isActive} />
          ) : null;
        })}

      {isCollapsible && (
        <div className="csw-option-result-tools">
          {isSelect && (
            <button
              type="button"
              className="csw-btn csw-btn-link outline csw-result-expander"
              onClick={onSelectExpand}
              aria-expanded={selectExpanded}
            >
              <span className="csw-btn-txt">{i18n.t(selectExpanded ? "RESULT_COLLAPSE" : "RESULT_EXPAND")}</span>
              {selectExpanded ? <IconUpCaret /> : <IconDownCaret />}
            </button>
          )}
        </div>
      )}
    </div>
  );
};

OptionResult.propTypes /* remove-proptypes */ = {
  result: PropTypes.object.isRequired,
  isActive: PropTypes.bool,
};

export default OptionResult;
